import { graphql } from "react-relay";

export const UpsertAWSAccountDiscoveryMutation = graphql`
  mutation UpsertAWSAccountDiscoveryMutation(
    $input: UpsertAWSAccountDiscoveryInput!
  ) {
    upsertAWSAccountDiscovery(input: $input) {
      accountDiscovery {
        config {
          ... on AWSAccountDiscoveryConfig {
            custodianRole
            externalID
            memberRole
            orgID
            orgRole
          }
        }
        description
        id
        name
        provider
        schedule {
          suspended
        }
        statusInfo {
          details {
            at
            component
            message
            status
          }
        }
      }
    }
  }
`;
